<template>
  <!--<div class="loading" id="loading" v-show="isShowLoad">-->
    <!--<div class="loadingBox">-->
      <!--<img src="//i0.letvimg.com/lc06_img/201812/28/17/41/load.png">-->
    <!--</div>-->
  <!--</div>-->
  <div class = "showBox">
    <img :src="imgs[getParamUrl('page')].image" />
  </div>
</template>

<script>
  export default {
    name: 'sy_staticActivity',
    data () {
      return {
        imgs: {
          1: {title: '充值赠送定制专属私人座驾', image: '//i1.letvimg.com/lc04_img/202007/31/11/12/img1.png'},
          2: {title: '愚人节活动', image: '//i2.letvimg.com/lc02_img/202003/27/16/43/img2.png'},
          3: {title: '抢热榜活动', image: '//i0.letvimg.com/lc06_img/202004/21/17/13/hourRank.png'},
          4: {title: '相约520', image: '//i1.letvimg.com/lc05_img/202005/12/10/55/img520.png'},
          5: {title: '观影厅指南', image: '//i0.letvimg.com/lc02_img/202005/19/10/28/img4.png'},
          6: {title: '整治电信诈骗专项活动公告', image: '//i2.letvimg.com/lc04_img/202005/21/18/54/img5.png'},
          7: {title: '礼物失效公告', image: '//i2.letvimg.com/lc03_img/202005/25/17/01/imgh5.png'},
          8: {title: '周年庆活动', image: '//i3.letvimg.com/lc06_img/202006/11/16/37/imgH5.png'},
          9: {title: '清朗行动', image: '//i2.letvimg.com/lc01_img/202007/28/14/07/imgH5.png'},
          10: {title: '年度庆典', image: '//i3.letvimg.com/lc07_img/202011/12/14/23/imgH5.png'},
          11: {title: '捕鱼游戏暂停公告', image: 'http://i1.letvimg.com/lc03_lemf/202011/27/16/14/imgh5.png'},
          12: {title: '幸运星暂停发放公告', image: 'http://i1.letvimg.com/lc02_img/202012/11/12/36/img.png'},
          13: {title: '充值定制座驾公告', image: '//cdn.svoice.le.com/uploads/22/00/220054fd12fef685547fc4e1a69b4a7a.png'},
          14: {title: '2021年7月活动公告', image: '//i3.letvimg.com/lc07_lemf/202107/05/15/31/h5.jpg'},
          15: {title: '2021最美声音公告', image: '//i1.letvimg.com/lc03_lemf/202108/09/10/24/h5.jpg'},
        },
        pageid:0,
      }
    },
    computed: {
    },
    mounted() {
      this.pageid = this.getParamUrl('page');
      document.title = this.imgs[this.pageid].title;
    },
    methods: {
      getParamUrl(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        return '';
      }
    }

  }
</script>
<style>
  *{margin: 0;padding: 0}
  .showBox{width: 100%;height: 100%;}
  .showBox img{width: 100%;height: auto;}
  /* loading页 */
  .loading {  position: fixed;  top:0;  z-index: 10;  width: 100%;  height: 100%; background: rgba(255,255,255,0.7);  }
  .loadingBox {  position: relative;  width: 100%;  height: 100%;  }
  .loadingBox img {  width: 32px;height: 32px;  position: absolute; left: 50%;top: 50%; margin: -16px 0 0 -16px;
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
  }
  @-webkit-keyframes spin {
    from {  -webkit-transform: rotate(0deg);  }
    to {  -webkit-transform: rotate(360deg);  }
  }
  @keyframes spin {
    from {  transform: rotate(0deg);  }
    to {  transform: rotate(360deg);  }
  }
</style>
